export const MultyTitileCard = ({ title, sections, className, svgChild }) => {
  return (
    <div className="section-card">
      <div className={className}>
        <div className="text-left" style={{ lineHeight: "normal" }}>
          <h6 className="text-light fs-5">{title}</h6>
          {sections.map((section, index) => (
            <div key={index} className="mb-3">
              <h6 className="text-light fs-5">{section.title}</h6>
              <ul className="text-light ps-3">
                {section.items.map((item, idx) => (
                  <li key={idx} className="mb-1">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div>{svgChild}</div>
    </div>
  );
};
